import { Badge, Color, Icon, NavListItemText } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useMatch, useNavigate } from 'react-router'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { getOrganizationViewUrl } from '../../../../utils/routing/getOrganizationViewUrl'
import { reactRoute } from '../../../../utils/routing/reactRoute'
import { UNSORTED_FOLDER_ID } from '../../constants'
import { useDmsUserRole } from '../../hooks/useDmsUserRole'
import { useFetchFolderContents } from '../../hooks/useFetchFolderContents'
import * as Styled from './styles'

export const UnsortedNavItem = (): ReactElement | null => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { organization } = useUserOrganization()
  const { isCpaExpertMode } = useDmsUserRole()
  const { documents } = useFetchFolderContents(UNSORTED_FOLDER_ID, { enabled: isCpaExpertMode })

  const unsortedRoute = reactRoute.organization.documents.getUnsortedRoute()
  const unsortedUrl = organization ? getOrganizationViewUrl(organization.url, unsortedRoute) : ''
  const isActive = !!useMatch(unsortedUrl)

  const handleNavItemClick = useCallback(() => {
    if (unsortedUrl) {
      navigate(unsortedUrl)
    }
  }, [navigate, unsortedUrl])

  if (!isCpaExpertMode) {
    return null
  }

  return (
    <Styled.NavItemWrapper>
      <Styled.NavItem $isSelected={isActive} onClick={handleNavItemClick}>
        <Icon color={Color.Grey700} icon="box" size="sm" />
        <NavListItemText>{t('documents.unsorted.nav_label')}</NavListItemText>
        {documents.length > 0 && (
          <Styled.CountBadgeWrapper>
            <Badge color="accent" mode="subtle">
              {documents.length}
            </Badge>
          </Styled.CountBadgeWrapper>
        )}
      </Styled.NavItem>
    </Styled.NavItemWrapper>
  )
}
